module.exports = __webpack_public_path__ + "img/andrin_bern_regen_ocular.b1393011.jpg";